<div [formGroup]="rangeFormGroup">
  <div class="label-filter">
    <label class="form-field__label" [ngClass]="{ 'disabled-control': disableFilter }" [attr.for]="filter().key">{{ filter().value
    }}</label>
    @if (isLandingPage()) {
      <div
        [ngClass]="{ 'disabled-control': disableFilter }"
        miq-filter-option
        [filter]="filter()"
        [form]="form()"
      ></div>
    }
  </div>
  <div class="form-field__container">
    @switch (filter().inputType) {
      <!-- DATES -->
      @case ('date') {
        <div class="flex-form">
          <mat-form-field appearance="outline">
            <input
              matInput
              [disabled]="fromControl?.disabled || disableFilter"
              autocomplete="no-autofill"
              readonly
              formControlName="from"
              [matDatepicker]="fromRangeDatePicker"
              [placeholder]="'recordsSearch.from' | translate"
              (dateChange)="dateEvent('from', $event)"
              [max]="maxDate"
              />
              <mat-datepicker-toggle matSuffix [for]="fromRangeDatePicker"></mat-datepicker-toggle>
              @if (filter().inputType === 'date' && displayFromClearButton) {
                <em
                  class="value-clear pi pi-times-circle"
                  (click)="clearDateFilter('from')"
                ></em>
              }
              <mat-datepicker #fromRangeDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="">
              <input
                matInput
                autocomplete="no-autofill"
                readonly
                [disabled]="toControl?.disabled || disableFilter"
                formControlName="to"
                [matDatepicker]="toRangeDatePicker"
                [placeholder]="'recordsSearch.to' | translate"
                (dateChange)="dateEvent('to', $event)"
                [min]="minDate"
                />
                <mat-datepicker-toggle matSuffix [for]="toRangeDatePicker"></mat-datepicker-toggle>
                @if (filter().inputType === 'date' && displayToClearButton) {
                  <em
                    class="value-clear pi pi-times-circle"
                    (click)="clearDateFilter('to')"
                  ></em>
                }
                <mat-datepicker #toRangeDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          }
          <!-- MAXVALUE -->
          @case ('maxvalue') {
            <div>
              <div>
                @switch (filter().dataType) {
                  @case ('date' || 'timestamp with time zone') {
                    <div>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          autocomplete="no-autofill"
                          readonly
                          [disabled]="toControl?.disabled"
                          formControlName="to"
                          [matDatepicker]="maxValueDatePicker"
                          [placeholder]="'recordsSearch.chooseDate' | translate"
                          />
                          <mat-datepicker-toggle matSuffix [for]="maxValueDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #maxValueDatePicker></mat-datepicker>
                        </mat-form-field>
                      </div>
                    }
                    @default {
                      <mat-form-field appearance="outline">
                        <div>
                          <input
                            matInput
                            autocomplete="no-autofill"
                            formControlName="to"
                            [placeholder]="'recordsSearch.max' | translate"
                            [type]="filter().dataType === 'numeric' ? 'number' : 'text'"
                            />
                          </div>
                        </mat-form-field>
                      }
                    }
                  </div>
                </div>
              }
              <!-- MINVALUE -->
              @case ('minvalue') {
                <div>
                  <div>
                    @switch (filter().dataType) {
                      @case ('date' || 'timestamp with time zone') {
                        <div>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              autocomplete="no-autofill"
                              readonly
                              [disabled]="fromControl?.disabled"
                              (onChange)="minVal()"
                              formControlName="from"
                              [matDatepicker]="maxValueDatePicker"
                              [placeholder]="'recordsSearch.chooseDate' | translate"
                              />
                              <mat-datepicker-toggle matSuffix [for]="maxValueDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #maxValueDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        }
                        @default {
                          <mat-form-field appearance="outline">
                            <div>
                              <input
                                matInput
                                autocomplete="no-autofill"
                                [disabled]="toControl?.disabled"
                                [placeholder]="'recordsSearch.min' | translate"
                                formControlName="from"
                                 [type]="filter().dataType === 'numeric' ? 'number' : 'text'"
                                />
                              </div>
                            </mat-form-field>
                          }
                        }
                      </div>
                    </div>
                  }
                  <!-- For filters with dataType as numeric or integer -->
                  @case ('number') {
                    <div class="flex-form">
                      <mat-form-field floatLabel="never" appearance="outline">
                        <input
                          matInput
                          miqOnlyNumbers
                          [restrictedKeyCodes]="restrictedKeyCodes"
                          [allowedKeyCodes]="allowedKeyCodes"
                          [readonly]="fromControl?.disabled"
                          autocomplete="no-autofill"
                          [placeholder]="'recordsSearch.min' | translate"
                          formControlName="from"
                          (keydown.enter)="updateForm($event, 'from')"
                          [type]="numberInputType"
                        /></mat-form-field>
                        <mat-form-field floatLabel="never" appearance="outline">
                          <input
                            matInput
                            miqOnlyNumbers
                            [restrictedKeyCodes]="restrictedKeyCodes"
                            [allowedKeyCodes]="allowedKeyCodes"
                            [readonly]="toControl?.disabled"
                            autocomplete="no-autofill"
                            [placeholder]="'recordsSearch.max' | translate"
                            formControlName="to"
                            (keydown.enter)="updateForm($event, 'to')"
                            [type]="numberInputType"
                          /></mat-form-field>
                        </div>
                      }
                      <!-- ALL OTHERS, for example where inputType = text -->
                      @default {
                        <div class="flex-form">
                          <mat-form-field floatLabel="never" appearance="outline">
                            <input
                              matInput
                              [readonly]="fromControl?.disabled"
                              autocomplete="no-autofill"
                              [placeholder]="'recordsSearch.min' | translate"
                              formControlName="from"
                              [type]="filter().inputType"
                              (keydown.enter)="updateForm($event, 'from')"
                            /></mat-form-field>
                            <mat-form-field floatLabel="never" appearance="outline">
                              <input
                                matInput
                                [readonly]="toControl?.disabled"
                                autocomplete="no-autofill"
                                [placeholder]="'recordsSearch.max' | translate"
                                formControlName="to"
                                [type]="filter().inputType"
                                (keydown.enter)="updateForm($event, 'to')"
                              /></mat-form-field>
                            </div>
                          }
                        }
                      </div>
                    </div>
